import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { useCurrentRawSnapshotsQuery } from "@/features/experience-curation/queries/useRawSnapshotsQuery";
import { useHasCommercialFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";
import { useFeatureFlag } from "@/features/experience-shared/composables/useFeatureFlag";

export const useCurationAdditionalDescription = defineStore("curation-content-additional-description-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const translationsQuery = useCurrentExperienceTranslationsQuery();
  const rawSnapshotsQuery = useCurrentRawSnapshotsQuery();

  const initialValue = computed(() => translationsQuery.data.value?.text2 ?? "");
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);

  const isRequired = false;
  const isReadonly = computed(() => curationExperienceStore.isReadonly);
  const isVisible = computed(() => useFeatureFlag("showAdditionalDescription"));

  const rawAdditionalDescription = computed(
    () => rawSnapshotsQuery.data.value?.rawSnapshot?.raw?.commercial?.additional_description || ""
  );
  const publishedRawAdditionalDescription = computed(
    () => rawSnapshotsQuery.data.value?.publishedRawSnapshot?.raw?.commercial?.additional_description || ""
  );
  const hasUnpublishedChange = useHasCommercialFieldChange("additional_description");
  const showRawFields = computed(() => curationExperienceStore.showRawFields);

  return {
    id: "additional_description",
    model,
    isRequired,
    isReadonly,
    isVisible,
    isFilled,
    hasChanges,
    hasUnpublishedChange,
    rawAdditionalDescription,
    publishedRawAdditionalDescription,
    showRawFields,
    reset,
  };
});
